import { MAX_CLAIM_DRAFTS } from './applyDraftChanges';

export const WHEN_TO_USE = `Draft changes to the claims and claim groups of the
open future state. Use this tool for every request to add, change, remove,
regroup or fix claims or groups. Changes are drafts. Nothing is saved until the
user accepts them. The user calls claims proposals; use that word in your summary.

Send every change the request needs in one batch. The future state is rendered
with the batch before anything is drafted, and a batch that fails to render
drafts nothing. 'rejectedBatch.reason' in the context says why. Tell the user and
offer a corrected batch. Do not resend the changes one at a time.

Kinds:
- 'createComponent', 'createReference': a presence claim for a new component
  or reference. Do not add a separate 'create' for it. Take the workspace id
  and type id only from your instruction. Never invent or copy one. If either
  is missing, do not call this tool. Ask for clarification. Every createComponent
  sets assertProperties.parent: an alias, a persisted id, or null for a root
  component. Never invent a persisted id.
- 'create': a claim about an existing component or reference, or a new group.
- 'update': changes a persisted or drafted claim or group. 'assertProperties'
  merges key by key and keeps omitted keys. claimGroupId null ungroups the
  claim. rootWorkspace cannot change.
- 'delete': drafts the deletion of a persisted claim or group, or removes a
  drafted create. Deleting a group deletes its claims.
- 'discard': drops your draft and restores the persisted version, if any.

Give each create an 'alias' that later changes can reference. Never reuse an
alias from an earlier batch. To reference a claim, group or entity (claimId,
claimGroupId, targetId, and parent, source and target in assertProperties), use
an alias from the context or this batch, or a persisted id.

Put several claims that serve one goal, such as a migration or a decommission,
in a new group and set its claimGroupId on each claim. Give the group a short
'name' and a 'description' of the goal. Do not group a single unrelated claim.
Discarding or deleting a group you created also removes the claims created in
it. This is rejected while a draft still moves another claim into the group, so
move or discard those drafts in the same batch.

A batch may leave at most ${MAX_CLAIM_DRAFTS} claim drafts. After the tool runs,
check each draft's evaluation. 'unmet' means the draft did not work. Fix it in a
new batch or tell the user why it cannot be met.`;

export const DRAFT_CHANGES_CONTEXT_DESCRIPTION = `The context shows the future
state with your drafts applied.
- 'claims', 'claimGroups': each item has 'alias' (its alias, else its id) and
  'draft' ('create', 'update', 'delete', or null if persisted without a draft).
  Groups also have 'name' and 'description'. targetId, claimGroupAlias and the
  parent, source and target keys of assertProperties use the same aliases.
- A claim's 'evaluation', null for a delete draft: 'status' (whether the claim
  is satisfied), 'op' (the change it makes), 'reason' (why it is unmet) and
  'conflictingClaimAliases'.
- 'completion' counts satisfied claims. 'claimExecutionStatus' says whether the
  claims can be applied together.
- 'render' is 'loading' during evaluation and 'error' if it failed. The lists
  are then empty.
- 'rejectedBatch' is set when your last batch failed to render and was not
  drafted, otherwise null.`;
